module.exports = __webpack_public_path__ + "static/media/Finnovex-NA-2025.b254e177.png";